import { setContext, getContext } from 'svelte'

import { TRANSLATIONS } from '$lib/context.js'
import State from '$lib/utils/state.svelte.js'
import { translate } from '$lib/text.js'

/** @typedef {{ [key: string]: { [key: string]: string|{ [key: string]: string } }}} Translation */
/** @typedef {function(TemplateStringsArray|string, ...any): string} Text */

/** @param {...Translation} translations */
export function register(...translations) {
  const parent = getContext(TRANSLATIONS) || []
  translations = [...translations, ...parent]

  setContext(TRANSLATIONS, translations)

  let text = $derived.by(() => {
    /** @type {Text} */
    return (strings, ...values) => {
      return translate(strings, values, translations, State.language)
    }
  })

  return (strings, ...values) => text(strings, ...values)
}
